export default "__VITE_ASSET__D_QlFJ9s__"